import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kion-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss']
})
export class  StatusLabelComponent implements OnInit {

  @Input() text: string;
  @Input() class: string;
  @Input() theme: 'default' | 'large' | 'small' = 'default';

  // tslint:disable-next-line:no-output-rename
  @Output('clicked') labelClickedEmitter: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    if (this.class) {
      this.class = this.class.toLowerCase().replace(/ /g, '_')
    }
  }

  labelClicked(): void {
    this.labelClickedEmitter.emit();
  }

}
